import React from "react";
import { HandbookLayout } from "@austere-monorepo/components";
import posts from "../../posts.json";

function Handbook(props) {
  return <HandbookLayout docs={posts} title="Information" home="about" {...props} />;
}

export default Handbook;
